import {Component, Input, OnInit, ChangeDetectorRef} from '@angular/core';
import * as Highcharts from "highcharts/highstock";
import { HighchartsChartComponent } from "highcharts-angular";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-industry-bar-chart',
  templateUrl: './industry-bar-chart.component.html',
  styleUrls: ['./industry-bar-chart.component.scss'],
  imports: [HighchartsChartComponent, CommonModule],
  standalone: true,
})
export class IndustryBarChartComponent implements OnInit {

  @Input() dataRaw: any[] = [];
  @Input() subHeader: any = {};
  loaded = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = 'chart';
  chartOptions: Highcharts.Options = {};

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.initChart();
  }

  initChart() {
    this.loaded = false;

    this.chartOptions = {
      chart: {
        height: '500px'
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      tooltip: {
        valueSuffix: '%'
      },
      yAxis: {
        minorGridLineWidth: 0,
        min: 0,
        title: {
          text: ''
        },
        labels: {
          format: '{value}%'
        },
      },
      xAxis: {
        categories: Object.keys(this.dataRaw),
        gridLineWidth: 0,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y}%'
          }
        }
      },
      colors: ['#1B1A3E'],
      series: [{
        type: "column",
        name: 'Industry',
        data: Object.values(this.dataRaw)
      }]
    };
    setTimeout(() => { this.loaded = true; this.cdr.detectChanges(); });
  }

}
